module.exports = __webpack_public_path__ + "img/doc.33f6f934.svg";